angular
    .module('WizApp')
    .directive('jobDynamicRegisterOpener', [
        'EVENT_NAMES',
        '$rootScope',
        function (EVENT_NAMES, $rootScope) {
            return {
                restrict: 'A',
                scope: {
                    options: '<jobDynamicRegisterOpener'
                },
                link: function (scope, element) {
                    element.on('click', event => {
                        const options = {
                            cta: _.get(scope.options, 'login', false) ? 'login' : 'signup',
                            type: scope.options.type,
                            slug: scope.options.slug
                        };

                        $rootScope.$emit(EVENT_NAMES.jobDynamicRegisterLightbox.open, options);
                        scope.$apply();

                        event.stopPropagation();
                        event.preventDefault();
                    });
                }
            };
        }
    ]);
